import React from 'react'
import { Outlet } from 'react-router-dom'

const Tenant = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default Tenant
